<template lang="pug">
  EditDialog(ref="EditDialog" title="業務完了解除" @save="save" :displayDeleteButton="false" :hasTitleSuffix="false")
    template(v-slot:body)
      v-container(grid-list-md)
        v-layout(row wrap)
</template>

<script>
import EditDialog from "@/components/common/dialog/EditDialog";

import ApiHandler from "@/mixin/ApiHandler";
import EditForm from "@/mixin/EditForm";

export default {
  components: {
    EditDialog
  },
  mixins: [ApiHandler, EditForm],
  props: {
    release: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      controls: {
        index: null
      },
      record: {},
      tranData: {}
    };
  },
  methods: {
    /**
     * 初期データ
     */
    initData(data) {
      return {
        driverId: "driverId" in data.item ? data.item.driverId : null,
        resultRemark: "resultRemark" in data.item ? data.item.resultRemark : null,
        scheduledLoadingDate: data.loadingDate
      };
    },
    /**
     * 初期化処理
     */
    setTranData() {
      this.tranData = {
        driverId: this.record.driverId,
        scheduledLoadingDate: this.record.scheduledLoadingDate,
        remark: this.record.resultRemark
      };
    },
    /**
     * フォームの初期化
     * @param values
     */
    initForm(values) {
      this.record = Object.assign({}, this.initData(values));
      this.errors = {};
    },
    openDialog(item) {
      this.initForm(item);
      this.$refs.EditDialog.openDialog();
    },
    closeDialog() {
      this.$refs.EditDialog.closeDialog();
    },
    save() {
      this.setTranData();
      this.saveRecord(this.tranData).then(() => {
        this.$refs.EditDialog.closeDialog();
        this.$emit("saved");
      });
    }
  }
};
</script>
